export class GlobalStyles {
    static text = {
        fontFamily: 'Roboto-Medium',
        fontSize: 17,
        lightFont: 'Roboto-Regular',
        placeholderColor: '#595959'
    }

    static colors = {
        primary: '#bb802b',
        secondary: '#e3e5e6',
        danger: '#FF3B30',
        lightGray: 'lightgray',
        primaryBlue: '#007bff',
        dropdownBackground: '#edf9ff'
    }

    static navigationBar = {
        backgroundColor: '#f0eded',
        buttonColors: GlobalStyles.colors.primary
    }

    static button = {
        primaryColor: GlobalStyles.colors.primary,
        secondaryColor: GlobalStyles.colors.secondary,
        dangerColor: GlobalStyles.colors.danger,
        height: 44,
        radius: 10,
        padding: 5,
        margin: 5
    }

    static buttonText = {
        color: '#fff',
        fontSize: 20,
        disabledColor: '#a8a8a9',
        secondaryColor: GlobalStyles.colors.primary
    }

    static hyperlink = {
        color: GlobalStyles.colors.primary
    }

    static spinner = {
        color: GlobalStyles.colors.primary
    }

    static input = {
        height: 44,
        padding: 5,
        margin: 5
    }

    static dropdown = {
        backgroundColor: '#f0eded'
    }
}